// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.is_stat {\n  height : 18px;\n  width: 41px;\n  color: #BF1B39;\n  font-weight: bold;\n  padding-left: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
